var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{attrs:{"value":"tab1","type":"card"},on:{"tab-click":_vm.changeTab}},[_c('el-tab-pane',{attrs:{"label":"测试台产品","name":"tab1"}},[_c('material-standard-mapping-list',{ref:"tabBox"})],1),_c('el-tab-pane',{attrs:{"label":"COP程序维护","name":"tab2"}},[_c('cop-material-list',{ref:"tabCop"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }